import React, { FC } from 'react';
import { Alert } from '@mui/material';

export interface SettingsStatusAlertProps {
  active: boolean;
  activeText: string;
  inactiveText: string;
}

export const SettingsStatusAlert: FC<SettingsStatusAlertProps> = ({ active, activeText, inactiveText }) => {
  return (
    <Alert severity={active ? 'success' : 'info'} sx={{ width: '100%' }}>
      {active ? activeText : inactiveText}
    </Alert>
  );
};

export default SettingsStatusAlert;
